import { AssistantHttpGateway } from "../../../gateway/AssistantHttpGateway";
import EmailsCommunication from "../../../shared/constants/EmailsCommunication";
import { requesterFromUser } from "../../../shared/email/internal-email-layout";
import { TemplateDowngrade } from "../../../views/accounting/my-subscription/template-downgrade";
import { TemplateGrow } from "../../../views/accounting/my-subscription/template-grow";
import {
    alertFinancialPendencyDialogTemplate,
    paymentsPendingDialogTemplate,
    requestChangePlanDialogTemplate,
    requestSendedAlertDialogTemplate
} from "../../../views/accounting/my-subscription/my-subscription.dialog-templates";
import { UserDataAdapter } from "../../adpters/UserDataAdapter";
import { registerCustomerRequest } from "../CustomerRequest/register-customer-request";
import { EmailSESService } from "../EmailSES/EmailSES";
import { Events } from "../Events/Events";

export class RequestChangePlan {
    static dialogsLoadPromise = null;
    Events = new Events();
    AssistantHttpGateway = new AssistantHttpGateway();
    downgradeSuccessText = `Sua solicitação foi registrada com sucesso! Por favor, esteja ciente de que a conclusão do processo levará <span class="font-weight-semi-bold">até 60 dias</span> a partir da confirmação enviada por email.
        <br>
        <br>
        <u>Somente após esse período</u>, o contrato será alterado.`;
    growSuccessText =
        "Sua solicitação foi registrada com sucesso. Aguarde a confirmação por e-mail.";
    constructor({ DesnuDialogService, accountingEntity, isOnlyReduce }) {
        this.DesnuDialogService = DesnuDialogService;
        this.accountingEntity = accountingEntity;
        this.isOnlyReduce = isOnlyReduce;
        this.isDefaulter = this.accountingEntity.isDefaulter();
    }

    static ensureMySubscriptionDialogs() {
        if (!RequestChangePlan.dialogsLoadPromise) {
            RequestChangePlan.dialogsLoadPromise = import(
                /* webpackChunkName: "feature-accounting-my-subscription" */ "../../../views/accounting/my-subscription/my-subscription.entry"
            );
        }
        return RequestChangePlan.dialogsLoadPromise;
    }

    async execute(ev, selected = null) {
        await RequestChangePlan.ensureMySubscriptionDialogs();
        this.DesnuDialogService.custom({
            controller: "RequestChangePlanDialog",
            controllerAs: "$ctrl",
            targetEvent: ev,
            clickOutsideToClose: true,
            locals: {
                selected,
                isOnlyReduce: this.isOnlyReduce,
                templateHtml: requestChangePlanDialogTemplate,
                width: "430px",
                accountingEntity: this.accountingEntity
            },
            after: {
                hide: (form) => {
                    this.sendRequest({ form });
                },
                cancel: async () => {}
            }
        });
    }

    async sendRequest({ form }) {
        const isDrowngrade = [
            "Reduzir licenças",
            "Diminuir meu plano e reduzir licenças",
            "Diminuir meu plano (remover funcionalidades)"
        ].includes(form.change);
        if (isDrowngrade) {
            if (this.isDefaulter) {
                await this.onPaymentsPending();
                return { response: false, message: "defaulter" };
            } else {
                this.registerRequest({ tipo: "downgrade", form });
                await this.sendEmail({ type: "Downgrade", form });
            }
        } else {
            this.registerRequest({ tipo: "grow", form });
            await this.sendEmail({ type: "Grow", form });
        }
        this.Events.send(
            `minhaassinatura.solicitacao.mudancaplano.${form.change}`
        );
        await this.openAlertRequestSended(
            isDrowngrade ? this.downgradeSuccessText : this.growSuccessText,
            isDrowngrade ? "586px" : "450px"
        );
        return { response: true, message: "success" };
    }

    // Fire-and-forget: roda em paralelo ao e-mail e nunca rejeita (ver registerCustomerRequest).
    registerRequest({ tipo, form }) {
        return registerCustomerRequest(this.AssistantHttpGateway, {
            tipo,
            accountingId: this.accountingEntity.props?._id,
            detalhes: { motivo: form.change, informacao: form.information }
        });
    }

    async onPaymentsPending() {
        await RequestChangePlan.ensureMySubscriptionDialogs();
        this.DesnuDialogService.custom({
            clickOutsideToClose: true,
            controller: "PaymetsPendingCtrl",
            controllerAs: "$ctrl",
            locals: {
                titleLabel:
                    "Poxa! Não foi possível prosseguir com sua solicitação",
                description:
                    'Parece que há pendências no seu contrato. Baixe os boletos atrasados na área <strong>"Faturas Atrasadas"</strong> ao lado e efetue o pagamento.',
                templateHtml: paymentsPendingDialogTemplate,
                width: "528px"
            },
            after: {
                hide: (eventType = null) => {},
                cancel: () => {}
            }
        });
    }

    async openAlertFinancialPendency() {
        await RequestChangePlan.ensureMySubscriptionDialogs();
        this.Events.send("minhaassinatura.popup.pendenciafinanceira");
        this.DesnuDialogService.custom({
            controller: "AlertFinancialPendencyDialog",
            controllerAs: "$ctrl",
            clickOutsideToClose: true,
            locals: {
                templateHtml: alertFinancialPendencyDialogTemplate,
                width: "528px"
            },
            after: {
                hide: () => {},
                cancel: async () => {}
            }
        });
    }

    async sendEmail({ type, form }) {
        const emailSESService = new EmailSESService();
        const subject = `Solicitação de ${type}: ${this.accountingEntity.props.name}`;
        const accountingTemplateParams = this.modelerTemplateAccountingParams();
        const requester = this.modelerTemplateRequesterParams();
        const types = {
            Grow: TemplateGrow(accountingTemplateParams, form, requester),
            Downgrade: TemplateDowngrade(
                accountingTemplateParams,
                form,
                requester
            )
        };
        const templateString = types[type];
        const isProduction =
            publicSettings.url === "https://pro.nucont.com" ||
            publicSettings.url === "https://beta.nucont.com";
        const extraEmail = { name: "Lais", email: "lais.santos@nucont.com" };
        const emailsTo = isProduction
            ? EmailsCommunication
            : [
                  { name: "Lucas", email: "lucas.jorge.nucont@gmail.com" },
                  { name: "Michael", email: "michael.nucont@gmail.com" }
              ];
        if (
            isProduction &&
            accountingTemplateParams.internalStatus === "TRIAL E FREE"
        )
            emailsTo.push(extraEmail);
        const input = {
            subject: subject,
            to: emailsTo,
            from: {
                name: "Nucont",
                email: "nanda@nucont.com"
            },
            bodyOptions: {
                reference: "ComunicacaoInterna",
                defaultParams: {
                    subject: subject,
                    templateString
                }
            }
        };
        await emailSESService.sendBulk(input);
    }

    modelerTemplateRequesterParams() {
        return requesterFromUser(new UserDataAdapter().user());
    }

    modelerTemplateAccountingParams() {
        this.accountingEntity.createdAtClient();
        return {
            name: this.accountingEntity.props.name,
            hubspotId: this.accountingEntity.props.hubspot?._id || "N/A",
            superLogicaId:
                this.accountingEntity.props.superLogica?._id || "N/A",
            financialEmail:
                this.accountingEntity.props.financialEmail ||
                this.accountingEntity.props.email,
            seller: this.accountingEntity.props.seller?.name || "N/A",
            createdAt: this.accountingEntity.props.createdAtFormated,
            cs: this.accountingEntity.props.cs?.name || "N/A",
            contract: this.accountingEntity.props.contract,
            countCompany: this.accountingEntity.props.plan?.countCompany,
            internalStatus: this.accountingEntity.props.status,
            superlogicaStatus:
                this.accountingEntity.props.superLogica?.status || "N/A",
            integrationsHealth: this.accountingEntity.props.integrationsHealth
        };
    }

    async openAlertRequestSended(description, width) {
        await RequestChangePlan.ensureMySubscriptionDialogs();
        this.DesnuDialogService.custom({
            controller: "RequestSendedAlertDialog",
            controllerAs: "$ctrl",
            clickOutsideToClose: true,
            locals: {
                templateHtml: requestSendedAlertDialogTemplate,
                width,
                description
            },
            after: {
                hide: () => {},
                cancel: async () => {}
            }
        });
    }
}
